import { createContext } from "react";

import type { NeoSource } from "../../../pages/Neo/citations/neoSources";

/** Published by an assistant ``ConversationMessage`` so the markdown deep
 *  inside it (plain text and downloadable-document bodies alike) can resolve
 *  ``[[source:…]]`` markers into clickable chips without prop-drilling. A
 *  ``MarkdownMessage`` rendered without a provider drops every marker. */
export interface CopilotCitationContextValue {
  resolve: (sourceId: string) => NeoSource | undefined;
  /** False hides ``discharge_medrec:`` chips — their only destination is the
   *  beta-gated Med Rec tab. */
  medRecVisible: boolean;
  /** Open the source drawer for a clicked chip. ``claim`` is the sentence the
   *  chip was attached to. */
  onOpen: (sourceIds: string[], claim?: string) => void;
}

export const CopilotCitationContext =
  createContext<CopilotCitationContextValue | null>(null);
